module.exports = __webpack_public_path__ + "static/media/sedex.99a760fc.png";